import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList } from 'recharts';

// Redux
import { connect } from 'react-redux';

const mapStateToProps = state => ({
    usuarioActivo: state
})

const Example = (props) => {
    if (props.data !== undefined) {
        return (
            <ResponsiveContainer>
                <BarChart
                    width={'100%'}
                    height={'100%'}
                    data={props.data}
                    margin={{
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" stroke="#8884d8" />
                    <YAxis domain={[0, 'dataMax + 1']} hide={true} />
                    <Tooltip />
                    <Bar dataKey="q" fill="#8884d8" barSize={40}>
                        <LabelList dataKey="q" position="top" />
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        );
    }
    else return <h>No hay data</h>
}

export default connect(mapStateToProps)(Example);